<template>
  <div>
    <headers />
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/school/index">培训学院</el-breadcrumb-item>
        <el-breadcrumb-item
          :to="`/school/index?id=${classifyId}`"
          v-if="classifyName"
          >{{ classifyName }}</el-breadcrumb-item
        >
        <el-breadcrumb-item to="/school/index">{{
          details.name
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="title">
      {{ details.name }}
    </div>
    <div class="tab">
      <div
        class="tabCard"
        v-if="details.equityClassifyNames.length == 1"
        :style="
          'background:' +
          backGround[details.equityClassifyNames[0]] +
          ';color:' +
          colorEnum[details.equityClassifyNames[0]]
        "
      >
        <span
          v-for="(items, indexs) in details.equityClassifyNames"
          :key="indexs"
          >{{ items }}</span
        >专属课程
      </div>
      <div
        class="tabCard"
        v-else
        style="background: rgba(0, 216, 195, 0.1); color: #00d8c3"
      >
        <span
          v-for="(items, indexs) in details.equityClassifyNames"
          :key="indexs"
          ><span v-if="indexs != 0">/</span>{{ items }}</span
        >可查看
      </div>
      <div class="num">学习次数：{{ details.studyNum }}</div>
    </div>

    <div class="content">
      <div class="video" style="position: relative">
        <video
          class="video"
          muted
          preload
          ref="videoPlayer"
          @play="onPlay"
          @pause="onPause"
          @ended="onVideoEnded"
          @timeupdate="onTimeUpdate"
          controls
        >
          <source :src="videoUrl" type="video/mp4" />
        </video>
        <img
          v-if="showBtn"
          @click="togglePlay"
          class="playIcon"
          src="@/assets/images/play.png"
        />
      </div>

      <div class="rightBox">
        <div v-for="(item, index) in details.details" :key="index">
          <div
            class="cell"
            @click="changeAct(index)"
            :style="actIndex === index ? { background: '#E5FBF9' } : {}"
          >
            <div>
              <div
                class="cellTit1"
                :style="
                  actIndex === index ? { color: '#00D8C3 !important' } : {}
                "
              >
                {{ index + 1 }}.{{ item.fileName }}
              </div>
              <div class="cellTit2">
                时长：{{ formattedTime(item.durationNum) }}
              </div>
            </div>
            <div class="lastViewTime">
              <span v-if="item.state == 1">已观看</span>
              <span v-else>上次观看到{{ formatSeconds(item.viewTime) }}</span>
            </div>
          </div>
          <div class="line"></div>
        </div>
      </div>
    </div>
    <!-- 考试弹窗 -->
    <examModel v-if="examModel" :examModel="examModel">
      <div class="examModelContent">
        <div class="examModelTitle">恭喜你学完指定课程</div>
        <div class="examModelText">
          恭喜你学完指定课程，请开始结业考试吧！祝你好运……
        </div>
        <div class="examModelBtn">
          <div class="examModelBtnCancel" @click="examModel = false">取消</div>
          <div class="examModelBtnStart" @click="jumpExam">开始考试</div>
        </div>
      </div>
    </examModel>
    <footers />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import search from "@/components/search.vue";

import { videoView, videoReadAdd, videoStudy, videoStudyAdd } from "@/api/lx";
import examModel from "./examModel.vue";

export default {
  name: "Procucts",
  components: {
    headers,
    footers,
    search,
    examModel,
  },
  data() {
    return {
      backGround: {
        L1: "rgba(0, 216, 195, 0.1)",
        L2: "rgba(240, 193, 11, 0.1)",
        L3: "rgba(71, 177, 226, 0.1)",
        L4: "rgba(147, 93, 228, 0.1)",
      },
      colorEnum: {
        L1: "#00D8C3",
        L2: "#F0C10B",
        L3: "#47B1E2",
        L4: "#935DE4",
      },
      actIndex: 0,
      showBtn: true,
      id: "",
      details: {},
      list: [],
      videoUrl: "",
      classifyName: "",
      classifyId: "",
      videoTime: 0, //视频时长
      enterTime: 0, // 进入页面时间
      studyDuration: 0, // 学习时长
      videoId: "", // 当前选择视频的id
      examModel: false, // 考试弹窗
    };
  },
  mounted() {
    this.enterTime = new Date().getTime();
  },
  beforeDestroy() {
    // 页面卸载时计算学习时长
    const leaveTime = new Date().getTime();
    this.studyDuration = Math.floor((leaveTime - this.enterTime) / 1000);

    // 这里可以调用接口保存学习时长
    this.saveStudyDuration();
    this.examModel = false;
    if (this.articleDetail.details[this.actIndex].state == 2) {
      this.saveVideoTime();
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.classifyName = this.$route.query.classifyName;
    this.classifyId = this.$route.query.classifyId;
    this.getDetails();
  },

  methods: {
    formattedTime(val) {
      let minutes = Math.floor(val / 60);
      let remainingSeconds = val % 60;
      if (minutes > 0) {
        return `${minutes}分${remainingSeconds}秒`;
      } else {
        return `${remainingSeconds}秒`;
      }
    },
    getDetails() {
      videoView(this.id).then((res) => {
        this.details = res.data;
        this.videoUrl = this.details.details[this.actIndex].fileUrl;
        this.videoId = this.details.details[0].id;
        console.log("13", this.videoUrl);
        this.$refs.videoPlayer.load();
        this.showBtn = true;
        // this.$refs.videoPlayer.play().catch((error) => {
        //   console.error("自动播放失败:", error);
        // });
      });
    },
    changeAct(val) {
      if (val == this.actIndex) return;
      this.actIndex = val;
      this.videoUrl = this.details.details[this.actIndex].fileUrl;
      this.$refs.videoPlayer.load();
      this.showBtn = true;
      this.videoId = this.details.details[this.actIndex].id;
      // this.$refs.videoPlayer.play().catch((error) => {
      //   console.error("自动播放失败:", error);
      // });
    },
    onPlay() {
      // console.log("播放");
      this.showBtn = false;
    },
    onPause() {
      // console.log("暂停");
      this.showBtn = true;
      if (this.details.details[this.actIndex].state == 2) {
        this.saveVideoTime();
      }
    },
    togglePlay() {
      const video = this.$refs.videoPlayer;
      video.play();
    },
    // 秒数转换成分秒
    formatSeconds(value) {
      var secondsTime = parseInt(value); // 秒转成整数
      var minuteTime = 0; // 分
      var secondTime = 0; // 秒
      if (secondsTime > 60) {
        minuteTime = Math.floor(secondsTime / 60); // 获取分钟整数
        if (parseInt(secondsTime % 60) > 0) {
          secondTime = parseInt(secondsTime % 60);
          return minuteTime + "分" + secondTime + "秒";
        } else {
          return minuteTime + "分";
        }
      } else {
        return secondsTime + "秒";
      }
    },
    // 视频结束
    async onVideoEnded(e) {
      const currentVideo = this.details.details[this.actIndex];
      const totalDuration = currentVideo.durationNum;
      this.videoTime = totalDuration;

      this.getDetails();
      await this.saveVideoTime();
      await this.checkExam();
    },
    // 视频进度更新
    onTimeUpdate(e) {
      // 获取当前播放时间
      let currentTime = e.target.currentTime;
      this.videoTime = currentTime;
      console.log("当前播放时间(秒)视频进度更新:", currentTime);
    },
    // 保存学习时长
    async saveStudyDuration() {
      try {
        // 这里添加保存学习时长的接口调用
        const res = await videoStudyAdd({
          studyTime: this.studyDuration,
        });
        console.log("保存学习时长成功:", this.studyDuration);
      } catch (error) {
        console.error("保存学习时长失败:", error);
      }
    },
    // 保存已经观看多少秒视频
    async saveVideoTime() {
      // 获取当前视频的总时长
      const currentVideo = this.details.details[this.actIndex];
      const totalDuration = currentVideo.durationNum;
      console.log("当前视频的总时长:", totalDuration);
      console.log("当前观看时长:", this.videoTime);

      try {
        // 这里添加保存学习时长的接口调用
        const res = await videoReadAdd({
          id: this.videoId,
          state: this.videoTime >= totalDuration ? 1 : 2,
          viewTime: this.videoTime,
        });
      } catch (error) {
        console.error("保存学习时长失败:", error);
      }
    },
    // 查询是否学习完进行考试弹窗
    async checkExam() {
      const res = await videoStudy({ id: this.videoId });
      if (res.data.state === 1) {
        this.examModel = true;
      }
      //  state 1-弹出考试；2-不弹出
      console.log(res, "res");
    },
    // 跳转考试页面
    jumpExam() {
      this.$router.push({
        path: `/examination/index?id=${this.id}`,
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.custom-breadcrumb-item:hover {
  color: #fff !important;
}
.title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 26px;
  color: #00161a;
  line-height: 37px;
  margin-left: 50px;
  margin-top: 30px;
}
.tab {
  display: flex;
  align-items: center;
  margin-top: 8px;
  .tabCard {
    padding: 0 7px;
    height: 26px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    line-height: 26px;
    text-align: center;
    margin-left: 50px;
    margin-right: 15px;
  }
  .num {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #525f66;
    line-height: 20px;
  }
}
.content {
  width: 100%;
  padding: 0 50px;
  box-sizing: border-box;
  margin-top: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin-bottom: 54px;
  .video {
    width: 1296px;
    height: 729px;
    background-color: #00161a;
  }
  .playIcon {
    position: absolute;
    width: 120px;
    height: 120px;
    top: 304px;
    left: 588px;
    cursor: pointer;
  }
  .rightBox {
    width: 524px;
    height: 729px;
    background: #ffffff;
    .cell {
      width: 100%;
      padding: 20px 30px;
      margin: 0 auto;
      box-sizing: border-box;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .cellTit1 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #00161a;
        line-height: 25px;
      }
      .cellTit2 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #829199;
        line-height: 20px;
        margin-top: 15px;
      }
      .lastViewTime {
        background: #00d8c3;
        padding: 2px 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        line-height: 20px;
      }
    }
    .line {
      width: 464px;
      height: 1px;
      background: #e6edf0;
      margin: 0 auto;
    }
  }
}

.examModelContent {
  padding: 30px 20px 30px 30px;
  .examModelTitle {
    margin-bottom: 25px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #00161a;
    line-height: 28px;
  }
  .examModelText {
    margin-bottom: 70px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #525f66;
    line-height: 22px;
    text-align: left;
  }
  .examModelBtn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .examModelBtnCancel {
      width: 120px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #e6edf0;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #00161a;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }
    .examModelBtnStart {
      margin-left: 10px;
      width: 120px;
      height: 40px;
      background: #00d8c3;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 14px;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>